<template>
  <div
    v-if="show"
    class="modal-container"
    @click="closeModal()"
  >
    <div
      class="modal-wrapper"
      :style="{ backgroundColor: $store.registratorBackgroundColor }"
    >
      <div
        class="modal-text-wrapper"
        :style="{ color: $store.registratorCaptionColor }"
      >
        <p
          class="modal-text"
        >
          {{ 'registrator_label_session_close' | translate }}:
        </p>
        <p class="seconds-left">
          {{ secondsLeft }}
        </p>
      </div>
      
      <svg
        class="modal-button-close"
        width="54"
        height="54"
        viewBox="0 0 54 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="closeModal()"
      >
        <path
          d="M27 53.6668C12.272 53.6668 0.333313 41.7282 0.333313 27.0002C0.333313 12.2722 12.272 0.333496 27 0.333496C41.728 0.333496 53.6666 12.2722 53.6666 27.0002C53.6666 41.7282 41.728 53.6668 27 53.6668ZM27 23.2295L19.4586 15.6855L15.6853 19.4588L23.2293 27.0002L15.6853 34.5415L19.4586 38.3148L27 30.7708L34.5413 38.3148L38.3146 34.5415L30.7706 27.0002L38.3146 19.4588L34.5413 15.6855L27 23.2295Z"
          fill="#3C3C43"
          fill-opacity="0.3"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import ModalMixin from '../mixins/ModalMixin';

export default {
  name: 'ModalCountdown',
  mixins: [ModalMixin],
  props: {
    countdownSeconds: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      secondsLeft: null,
      countdownInterval: null
    }
  },
  watch: {
    show(value) {
      if (value) {
        this.initCountdownInterval();
      } else {
        clearInterval(this.countdownInterval);
      }
    }
  },
  destroyed() {
    clearInterval(this.countdownInterval);
  },
  methods: {
    initCountdownInterval() {
      clearInterval(this.countdownInterval);

      this.secondsLeft = this.countdownSeconds;

      this.countdownInterval = setInterval(() => {
        if (--this.secondsLeft === 0) {
          clearInterval(this.countdownInterval);
          this.$emit('countdowned');
        }
      }, 1000);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/Modal.scss';

.modal-text {
  font-weight: 600;
  font-size: 30px;
}

.modal-wrapper {
  width: 500px;
  padding: 64px 40px 45px 40px;
  border-radius: 20px;
}

.modal-text-wrapper {
  margin-bottom: 63px;
}

.seconds-left {
  margin-top: 16px;
  font-weight: 500;
  font-size: 64px;
  text-align: center;
}
</style>
